exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".next-date-calendar[data-v-098f677f] {\n  max-height: 0;\n  -webkit-transition: max-height 400ms ease-in-out;\n  -moz-transition: max-height 400ms ease-in-out;\n  -ms-transition: max-height 400ms ease-in-out;\n  -o-transition: max-height 400ms ease-in-out;\n  transition: max-height 400ms ease-in-out;\n  overflow: hidden;\n}\n.next-date-calendar.expanded[data-v-098f677f] {\n  max-height: 38em;\n}\n.next-date-calendar .options-calendar[data-v-098f677f] {\n  margin: 1.5em auto;\n}\n", ""]);

// exports
